import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import OkCancelModal from '@/shared/components/OkCancelModal';
import DatePicker from '@/shared/components/input/DatePicker';
import moment from 'moment';
import { falseFunc, isBeforeMinimum } from '@/shared/utils/validationHelpers';
import messages from './taskMessages';

export default class ChangeTaskDeadlineModal extends Component {
  state = {
    deadline: moment.utc(),
  };

  componentDidMount() {
    this.form = React.createRef();
  }

  componentDidUpdate(prevProps) {
    const { show } = this.props;

    if (prevProps.show !== show) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState(() => ({
        deadline: moment.utc(),
      }));
    }
  }

  static propTypes = {
    onSave: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    onClose: PropTypes.func.isRequired,
    show: PropTypes.bool,
  };

  static defaultProps = {
    show: false,
  };

  closeModal = () => {
    const { onClose } = this.props;
    onClose();
  };

  validate() {
    const { deadline } = this.state;
    if (isBeforeMinimum(deadline)) return false;

    if (!this.form || !this.form.current) return true;
    return this.form.current.reportValidity();
  }

  deadlineChanged = input => {
    this.setState({
      deadline: input,
    });
  };

  onSave = () => {
    const { deadline } = this.state;
    const { onSave } = this.props;
    if (!this.validate()) return Promise.reject(new Error('invalid form'));

    const parameters = {
      deadline,
      field: 0,
    };

    return onSave(parameters);
  };

  render() {
    const { show, intl } = this.props;
    const { deadline, dateFocused } = this.state;

    return (
      <OkCancelModal
        title={intl.formatMessage(messages.ChangeTaskDeadline)}
        show={show}
        onClose={this.closeModal}
        disabled={!this.validate()}
        onSave={this.onSave}
      >
        {show && (
          <form ref={this.form}>
            <div className="form-horizontal">
              <div
                className={classNames('form-group', {
                  'has-error': isBeforeMinimum(deadline),
                })}
              >
                <label className="control-label col-sm-3">
                  <FormattedMessage {...messages.Deadline} />
                </label>
                <div className="col-md-6">
                  <DatePicker
                    placeholder={intl.formatMessage(messages.Deadline)}
                    date={deadline}
                    onDateChange={this.deadlineChanged}
                    focused={dateFocused}
                    onFocusChange={({ focused }) => this.setState({ dateFocused: focused })}
                    id="taskDeadline"
                    block
                    small
                    isOutsideRange={falseFunc}
                  />
                </div>
              </div>
            </div>
          </form>
        )}
      </OkCancelModal>
    );
  }
}
